import { Location } from 'history'

export const isOnAdmin = (location: Location) =>
  location.pathname.includes('/admin')

export const navigateToHome = () => {
  window.location.href = '/'
}
